export const APP_NAME = "Randi Kummedaam"